import { render, staticRenderFns } from "./OnHoldItemArticle.vue?vue&type=template&id=6a30b25e&scoped=true"
import script from "./OnHoldItemArticle.vue?vue&type=script&lang=js"
export * from "./OnHoldItemArticle.vue?vue&type=script&lang=js"
import style0 from "./OnHoldItemArticle.vue?vue&type=style&index=0&id=6a30b25e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30b25e",
  null
  
)

export default component.exports